<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="45%"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-row>
      <el-form
        ref="form"
        :model="custDiagnose"
        :rules="rules"
        label-width="140px"
      >
        <el-form-item label="账户问题及动作:" prop="Approach">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="账户问题及动作"
            v-model="custDiagnose.Approach"
          ></el-input>
        </el-form-item>
        <el-form-item label="下步规划:" prop="Planning">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入下步规划"
            v-model="custDiagnose.Planning"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题卡点:" prop="Question">
          <el-input
            v-model="custDiagnose.Question"
            placeholder="请输入问题卡点"
          ></el-input>
        </el-form-item>
        <el-form-item label="所需支持:" prop="Support">
          <el-input
            v-model="custDiagnose.Support"
            placeholder="请输入所需支持"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="EventCancel">取 消</el-button>
      <el-button type="primary" @click="EventSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {} from "@/until/ZeusApiSDK/Logic/CustomerProfile";
export default {
  name: "addDiagnose",
  data() {
    return {
      rules: {
        Approach: [
          { required: true, message: "账户问题及动作", trigger: "blur" }
        ],
        Planning: [
          { required: true, message: "请输入下步规划", trigger: "blur" }
        ],
        Question: [
          { required: true, message: "请输入问题卡点", trigger: "blur" }
        ],
        Support: [
          { required: true, message: "请输入所需支持", trigger: "blur" }
        ]
      }
    };
  },
  props: {
    custDiagnose: {
      type: Object
    },
    visible: {
      type: Boolean
    },
    dialogTitle: {
      type: String
    }
  },
  created() {},
  methods: {
    handleAreaChange(value) {
      console.log(value);
    },
    handleClose() {
      // this.visible = false;
      this.$emit("close");
    },
    EventCancel() {
      this.$emit("close");
    },
    EventSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$emit("submit");
        } else {
          this.$message.error("请检查表单填写完毕后再试~");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.upbox {
  margin: 0;
  border: 0;
  padding: 0;
}
.upload-demo {
  float: left;
}
.cr {
  float: left;
  color: #d9001b;
  margin: 10px 0 0 10px;
  line-height: 20px;
}
.clear {
  clear: both;
}
</style>
